export default "__VITE_ASSET__DL5mNyaR__"